'use client';
var IDENT = "Collapse";
var defaultProps = {
    transitionDuration: 200,
    timingFunction: "ease",
    animateOpacity: true
};

export { IDENT, defaultProps };
